<template>
  <div
    class="wrapper-container"
    :style="{ 'position': position }"
  >
    <div class="container mx-auto">
      <div
        v-if="facilitiesArray.length > 0"
        class="nearby-facilities z-[10] top-10"
      >
        <div class="flex flex-col">
          <h4 class="font-bold mb-4 font-secondary">
            {{ $t('hotelNearbyFacilitiesNew') }}
          </h4>
          <div
            v-for="(facility, index) in facilitiesArray"
            :key="index"
            class="flex facilities-list"
          >
            <span class="facilities-name font-bold">
              {{ facility.name }}
            </span>
            <span class="facilities-distance">
              {{ facility.distance }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  hotelInfo: {
    type: Object,
    required: true,
  },

  position: {
    type: String,
    default: 'absolute',
  },
})

const facilitiesArray = computed(() => {
  if (!props.hotelInfo.facilities_text && !props.hotelInfo.nearby_facilities_text) {
    return []
  }
  const facilitiesText = props.hotelInfo.facilities_text || props.hotelInfo.nearby_facilities_text
  if (/<[a-z][\s\S]*>/i.test(facilitiesText)) {
    return []
  }
  return facilitiesText.split(/ [^a-zA-ZåäöÅÄÖ] /).map(item => {
    const parts = item.trim().split(' ')

    if (parts.length < 2) {
      return { name: item, distance: '' }
    }

    const distance = parts.pop()
    const name = parts.join(' ')
    return { name, distance }
  })
})
</script>

<style lang="scss" scoped>
.wrapper-container {
  width: 100%;
  top: 10%;
  pointer-events: none;
  display: flex;
}
.nearby-facilities {
  background-color: theme('colors.light-turquoise');
  padding: 2rem 1.8rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
  width: fit-content;
}
.facilities-list {
  justify-content: space-between;
}
.facilities-name {
  margin-right: 50px;
}
@media (max-width: theme('screens.lg')) {
  .container {
    padding: 0;
  }
  .nearby-facilities {
    top: 0 !important;
    left: 0;
    width: 100%;
  }
  .facilities-list {
    align-items: end;
  }
}
</style>